var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateDashboard',{attrs:{"client-is-required":false,"route":_vm.$listRoutes.dashboardOperations,"filters-route":_vm.$listRoutes.dashboardOperationsFilters,"comparaison":true,"title":_vm.$t('dashboard-operations.title')}})
}
var staticRenderFns = []

export { render, staticRenderFns }